"use client";
/**
 * Sticky entry point to the shortlist on menu-only links — the counterpart to
 * the mini-cart bar on ordering links. Mirrors its shape so the two never look
 * like different apps, but sits lower: there is no bottom nav in menu-only
 * mode, so nothing to clear.
 */
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { StickyBar } from "./ui";
import { Price } from "./Price";
import { useShortlist } from "@/store/shortlist";

export function ShortlistBar() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { shortlistCount, shortlistTotal } = useShortlist();

  if (shortlistCount === 0) return null;

  return (
    <StickyBar
      style={{
        background: "var(--cart-bg)",
        color: "var(--cart-fg)",
        borderTop: 0,
        bottom: "calc(env(safe-area-inset-bottom, 0px) + 16px)",
        borderRadius: "var(--radius-card)",
        padding: 0,
        left: 16,
        right: 16,
        boxShadow: "0 14px 30px -10px rgba(0,0,0,0.35)",
      }}
    >
      <button
        onClick={() => navigate("/shortlist")}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          width: "100%",
          padding: "14px 16px",
          background: "transparent",
          border: 0,
          color: "var(--cart-fg)",
          cursor: "pointer",
          fontFamily: "inherit",
        }}
      >
        <div
          style={{
            width: 34,
            height: 34,
            borderRadius: 999,
            background: "rgba(255,255,255,0.15)",
            display: "grid",
            placeItems: "center",
            fontWeight: 700,
            fontSize: 13,
          }}
        >
          {shortlistCount}
        </div>
        <div style={{ flex: 1, textAlign: "start" }}>
          <div style={{ fontSize: 14, fontWeight: 600 }}>
            {t("v2.shortlist.view")}
          </div>
          <div style={{ fontSize: 12, opacity: 0.7, marginTop: 2 }}>
            {t(
              shortlistCount === 1
                ? "v2.home.items_one"
                : "v2.home.items_other",
              { count: shortlistCount },
            )}
          </div>
        </div>
        <div style={{ fontSize: 15, fontWeight: 700 }}>
          <Price amount={shortlistTotal} />
        </div>
      </button>
    </StickyBar>
  );
}
